import { c as _c } from "react/compiler-runtime";
import { useMutation } from "@tanstack/react-query";
import { type FormEvent, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "@/components/pop-ui/pop-toast";
import { useORPC } from "@/providers/orpc-provider";
import { CodeInput, type CodeInputRef } from "../components/code-input";
import { Button } from "../components/form-items";
import { PhoneInput } from "../components/phone-input";
import { AREA_LIST, formatPhoneParam, type UserFormErrors, validatePhoneNumber } from "../utils";
interface ChangePhoneFormProps {
  area: string;
  onFinish?: () => void;
}

// 更换绑定手机号表单
export function ChangePhoneForm(t0) {
  const $ = _c(69);
  const {
    area,
    onFinish
  } = t0;
  const [newPhone, setNewPhone] = useState("");
  const [code, setCode] = useState("");
  const [showCodeInput, setShowCodeInput] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      phone: "",
      code: ""
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [errors, setErrors] = useState(t1);
  const codeInputRef = useRef(null);
  const orpc = useORPC();
  const {
    t
  } = useTranslation();
  let t2;
  if ($[1] !== orpc.user.changePhoneOtp) {
    t2 = async phoneNumber => orpc.user.changePhoneOtp.call({
      phoneNumber
    }, {
      context: {
        headers: {}
      }
    });
    $[1] = orpc.user.changePhoneOtp;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] !== t) {
    t3 = () => {
      setShowCodeInput(true);
      setTimeout(() => {
        codeInputRef.current?.startCountdown();
      }, 500);
      toast.success(t("toast.success.verificationCodeSentToNewPhone"));
    };
    t4 = error => {
      console.error("Send verification code failed:", error);
      const errorMessage = error?.message || error?.data?.message || t("toast.error.sendCodeFailedTryLater");
      toast.error(errorMessage);
    };
    $[3] = t;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = {
      mutationFn: t2,
      onSuccess: t3,
      onError: t4
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const {
    mutate: sendVerificationCode,
    isPending: isSendingCode
  } = useMutation(t5);
  let t6;
  if ($[10] !== orpc.user.changePhone) {
    t6 = orpc.user.changePhone.mutationOptions();
    $[10] = orpc.user.changePhone;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== onFinish || $[13] !== t) {
    t7 = () => {
      toast.success(t("toast.success.newPhoneVerifiedBindingUpdated"));
      if (onFinish) {
        onFinish();
      }
    };
    $[12] = onFinish;
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = error_0 => {
      console.error("Change phone failed:", error_0);
      const errorMessage_0 = error_0?.message || error_0?.data?.message || t("toast.error.changePhoneFailedTryLater");
      toast.error(errorMessage_0);
    };
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
    t9 = {
      ...t6,
      onSuccess: t7,
      onError: t8
    };
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const {
    mutate: changePhone,
    isPending: isChanging
  } = useMutation(t9);
  let t10;
  if ($[21] !== area || $[22] !== newPhone || $[23] !== sendVerificationCode || $[24] !== t) {
    t10 = async () => {
      setErrors({
        phone: "",
        code: ""
      });
      if (!newPhone) {
        setErrors(prev => ({
          ...prev,
          phone: t("error.enterNewPhoneNumber")
        }));
        return;
      }
      const cleanedInput = newPhone.replace(/\D/g, "");
      const result = validatePhoneNumber(cleanedInput, area);
      if (!result.valid) {
        setErrors(prev_0 => ({
          ...prev_0,
          phone: t("error.invalidPhoneNumber")
        }));
        return;
      }
      const areaInfo = AREA_LIST.find(item => item.code === area);
      if (areaInfo && result.regionCode !== areaInfo.phoneCode) {
        setErrors(prev_1 => ({
          ...prev_1,
          phone: t("error.invalidPhoneNumber")
        }));
        return;
      }
      const formattedPhone = formatPhoneParam(newPhone, area);
      sendVerificationCode(formattedPhone);
    };
    $[21] = area;
    $[22] = newPhone;
    $[23] = sendVerificationCode;
    $[24] = t;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const handleResendCode = t10;
  let t11;
  if ($[26] !== area || $[27] !== newPhone || $[28] !== sendVerificationCode || $[29] !== t) {
    t11 = async e => {
      e.preventDefault();
      setErrors({
        phone: "",
        code: ""
      });
      if (!newPhone) {
        setErrors(prev_2 => ({
          ...prev_2,
          phone: t("error.enterNewPhoneNumber")
        }));
        return;
      }
      const cleanedInput_0 = newPhone.replace(/\D/g, "");
      const result_0 = validatePhoneNumber(cleanedInput_0, area);
      if (!result_0.valid) {
        setErrors(prev_3 => ({
          ...prev_3,
          phone: t("error.invalidPhoneNumber")
        }));
        return;
      }
      const areaInfo_0 = AREA_LIST.find(item_0 => item_0.code === area);
      if (areaInfo_0 && result_0.regionCode !== areaInfo_0.phoneCode) {
        setErrors(prev_4 => ({
          ...prev_4,
          phone: t("error.invalidPhoneNumber")
        }));
        return;
      }
      const formattedPhone_0 = formatPhoneParam(newPhone, area);
      sendVerificationCode(formattedPhone_0);
    };
    $[26] = area;
    $[27] = newPhone;
    $[28] = sendVerificationCode;
    $[29] = t;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  const handleSendCode = t11;
  let t12;
  if ($[31] !== area || $[32] !== changePhone || $[33] !== code || $[34] !== newPhone || $[35] !== t) {
    t12 = e_0 => {
      e_0.preventDefault();
      setErrors({
        phone: "",
        code: ""
      });
      if (!code) {
        setErrors(prev_5 => ({
          ...prev_5,
          code: t("error.enterVerificationCode")
        }));
        return;
      } else {
        if (code.length !== 6) {
          setErrors(prev_6 => ({
            ...prev_6,
            code: t("error.enter6DigitVerificationCode")
          }));
          return;
        }
      }
      const formattedPhone_1 = formatPhoneParam(newPhone, area);
      changePhone({
        phoneNumber: formattedPhone_1,
        otp: code
      } as any);
    };
    $[31] = area;
    $[32] = changePhone;
    $[33] = code;
    $[34] = newPhone;
    $[35] = t;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  const handleSubmitChange = t12;
  const isLoading = isSendingCode || isChanging;
  const t13 = showCodeInput ? handleSubmitChange : handleSendCode;
  const t14 = isLoading || showCodeInput;
  let t15;
  if ($[37] !== t) {
    t15 = t("placeholder.newPhoneNumber");
    $[37] = t;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  const t16 = showCodeInput ? "bg-gray-100" : "";
  let t17;
  if ($[39] !== area || $[40] !== newPhone || $[41] !== t14 || $[42] !== t15 || $[43] !== t16) {
    t17 = <PhoneInput id="newPhone" area={area} value={newPhone} onChange={setNewPhone} disabled={t14} placeholder={t15} className={t16} />;
    $[39] = area;
    $[40] = newPhone;
    $[41] = t14;
    $[42] = t15;
    $[43] = t16;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== errors.phone) {
    t18 = errors.phone && <p className="text-destructive text-sm leading-[1.5]">{errors.phone}</p>;
    $[45] = errors.phone;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== t17 || $[48] !== t18) {
    t19 = <div className="space-y-2">{t17}{t18}</div>;
    $[47] = t17;
    $[48] = t18;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== code || $[51] !== errors.code || $[52] !== handleResendCode || $[53] !== isLoading || $[54] !== showCodeInput) {
    t20 = showCodeInput && <CodeInput ref={codeInputRef} value={code} onChange={setCode} onResend={handleResendCode} error={errors.code} disabled={isLoading} autoStartCountdown={false} />;
    $[50] = code;
    $[51] = errors.code;
    $[52] = handleResendCode;
    $[53] = isLoading;
    $[54] = showCodeInput;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] !== isChanging || $[57] !== isSendingCode || $[58] !== showCodeInput || $[59] !== t) {
    t21 = isSendingCode ? t("button.sending") : isChanging ? t("button.changing") : showCodeInput ? t("button.confirmChange") : t("button.sendCodeToNewPhone");
    $[56] = isChanging;
    $[57] = isSendingCode;
    $[58] = showCodeInput;
    $[59] = t;
    $[60] = t21;
  } else {
    t21 = $[60];
  }
  let t22;
  if ($[61] !== isLoading || $[62] !== t21) {
    t22 = <Button type="submit" className="w-full" size="lg" loading={isLoading}>{t21}</Button>;
    $[61] = isLoading;
    $[62] = t21;
    $[63] = t22;
  } else {
    t22 = $[63];
  }
  let t23;
  if ($[64] !== t13 || $[65] !== t19 || $[66] !== t20 || $[67] !== t22) {
    t23 = <form onSubmit={t13} className="space-y-3">{t19}{t20}{t22}</form>;
    $[64] = t13;
    $[65] = t19;
    $[66] = t20;
    $[67] = t22;
    $[68] = t23;
  } else {
    t23 = $[68];
  }
  return t23;
}